import { service } from '@ember/service';
import Component from '@glimmer/component';
import { t, type IntlService } from 'ember-intl';
import WLoginDialog from 'login/components/w-login-dialog';
import type { RegisterUserModel } from 'login/routes/register-user';

export default class RegisterUser extends Component<{ Args: { model: RegisterUserModel } }> {
  @service private intl!: IntlService;

  private get languageCandidates(): { value: string; label: string }[] {
    return this.args.model.languageCandidates.map((candidate) => {
      const code = candidate.trim();
      return {
        value: code,
        label: this.intl.t(`language.${code}`),
      };
    });
  }

  private get unitCandidates(): { value: string; label: string }[] {
    return this.args.model.unitCandidates.map((candidate) => {
      const code = candidate.trim();
      return {
        value: code,
        label: this.intl.t(`unit.${code}`),
      };
    });
  }

  <template>
    <WLoginDialog
      @pageTitle={{t 'login.title.registerUser'}}
      @dialogTitle={{t 'login.title.registerUser'}}
      @version={{@model.version}}
    >
      <form class='form' method='post' action='registerUser'>
        <div class='explanation-line'>
          <div>{{t 'login.verifiedText'}}</div>
          <div>{{t 'login.completeText'}}</div>
        </div>

        <div class='spacer-small'></div>

        <div class='inner-grid'>
          <div class='item label'>{{t 'login.firstNameLabel'}}:</div>
          <div class='item value'>
            <input type='text' name='firstname' autocomplete='given-name' autofocus />
          </div>

          <div class='item label'>{{t 'login.lastNameLabel'}}:</div>
          <div class='item value'>
            <input type='text' name='lastname' autocomplete='family-name' />
          </div>

          <div class='item label'>{{t 'login.emailLabel'}}:</div>
          <div class='item value'>
            <input type='text' name='email' autocomplete='email' />
          </div>

          <div class='item label'>{{t 'login.languaeLabel'}}:</div>
          <div class='item value'>
            <select name='language'>
              {{#each this.languageCandidates as |candidate|}}
                <option value={{candidate.value}}>
                  {{candidate.label}}
                </option>
              {{/each}}
            </select>
          </div>

          <div class='item label'>{{t 'login.unitLabel'}}:</div>
          <div class='item value'>
            <select name='unit'>
              {{#each this.unitCandidates as |candidate|}}
                <option value={{candidate.value}}>
                  {{candidate.label}}
                </option>
              {{/each}}
            </select>
          </div>
        </div>

        <div class='spacer'></div>

        <div class='expanded-line'>
          <div>
            {{! empty div for layout }}
          </div>
          <button type='submit' class='quick-button-right'>
            {{t 'login.registerUserButton'}}
          </button>
        </div>
      </form>
    </WLoginDialog>
  </template>
}
